import * as React from "react";
const IconHealthLiteracy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      d="M33 15a1 1 0 1 0-2 0v2.734c-.916.33-1.87.784-2.978 1.388a1 1 0 1 0 .956 1.756A23 23 0 0 1 31 19.882V23a1 1 0 1 0 2 0v-3.765c.884-.187 1.806-.249 2.986-.232a1 1 0 0 0 .028-2c-1.108-.016-2.071.032-3.014.196zM19.142 28.934c-3.097-1.187-4.716-1.462-7.632-1.434l-.02-2c3.18-.03 5.048.294 8.368 1.566zM11.51 22.5c2.916-.028 4.535.247 7.632 1.434l.716-1.868c-3.32-1.272-5.188-1.597-8.368-1.566zM19.142 18.934c-3.097-1.187-4.716-1.462-7.632-1.434l-.02-2c3.18-.03 5.048.294 8.368 1.566z"
    />
    <path
      
      fillRule="evenodd"
      d="m24 11.24.258-.055c4.996-2.406 9.301-4.136 15.268-2.608A1.97 1.97 0 0 1 41 10.492v.281q1.079.217 2.243.498a.99.99 0 0 1 .757.965v25.539c0 .633-.583 1.105-1.204.987-6.213-1.185-10.4-1.268-16.122-.4a3 3 0 0 1-5.348 0c-5.721-.868-9.91-.785-16.122.4A1.01 1.01 0 0 1 4 37.775V12.236c0-.458.311-.858.757-.965A60 60 0 0 1 7 10.773v-.281c0-.88.583-1.687 1.474-1.915 5.967-1.528 10.272.202 15.268 2.608zm1 1.807c4.98-2.404 8.734-3.88 14-2.54v22.548q0 .002-.008.008a.06.06 0 0 1-.052.013c-4.9-.898-8.681.037-12.795 1.826A3 3 0 0 0 25 34.171zm-2 .001v21.123a3 3 0 0 0-1.145.731c-4.114-1.79-7.896-2.724-12.795-1.826a.06.06 0 0 1-.053-.013h-.001L9 33.054V10.507c5.266-1.34 9.02.137 14 2.541m19-.015q-.51-.116-1-.218v20.24c0 1.31-1.21 2.21-2.421 1.989-3.776-.693-6.8-.193-10.073 1.052 4.573-.533 8.428-.402 13.494.487zM19.494 36.096c-3.272-1.245-6.297-1.745-10.073-1.052C8.211 35.266 7 34.365 7 33.055v-20.24q-.49.102-1 .218v23.55c5.066-.889 8.92-1.02 13.494-.487"
      clipRule="evenodd"
    />
  </svg>
);
export default IconHealthLiteracy;
